import { createBrowserRouter } from 'react-router-dom'
import { ErrorPage } from './pages/error-page'
import { BookViewerPage } from './pages/book-viewer-page'
import { loadBook } from './loaders'
import { BookListPage } from './pages/book-list-page'

export function getRouter() {
  return createBrowserRouter([
    {
      path: '/',
      errorElement: <ErrorPage message="Ошибка при загрузки страницы"/>,
      children: [
        {
          errorElement: <ErrorPage message="Ошибка при загрузке книги"/>,
          path: 'books/:bookId',
          loader: async ({ params }) => await loadBook(params.bookId!),
          element: <BookViewerPage/>,
        },
        {
          path: '',
          element: <BookListPage/>,
        },
      ],
    },
  ])
}
